import Reflux from 'reflux'

export default Reflux.createActions([
  'subscribe',
  'unsubscribe',
  'dataUpdate'
])
